<template>
  <div :class="s.publicityDetail2">    
    <h3>《防范和处置非法集资条例》培训 </h3>
    <p>非法集资严重损害人民群众切身利益，破坏正常经济金融秩序，危害社会稳定大局。近日，为树立员工风险意识，远离非法集资，广东智选保代开展《防范和处置非法集资条例》培训。</p>
    <img :src="require('../images/ic_publicity_detail2_1.jpg')"/>
    <p>本次培训，从《防范和处置非法集资条例》宣导、防范非法集资相关知识与非法集资案例三方面进行重点讲解，要求公司各部门提高政治站位，以案为鉴，举一反三，同时，员工自身要提升风险防范意识和能力，在日常生活中主动远离非法集资，共同守护幸福家庭。</p>
    <img :src="require('../images/ic_publicity_detail2_2.jpg')"/>
    <p>通过本次培训，广东智选保代员工对非法集资的危害有了更加清醒的认知，对参与非法集资的后果有了更加详细的了解，为公司持续做好打击和防范非法集资工作打下良好基础。广东智选保代将协助监管部门、司法机关依法查处违法行为，为全社会共同防范和打击非法集资活动贡献出一份力量，共建美好和谐社会。</p>
  </div>
</template>

<script>
export default {
  name: 'PublicityDetail2',
  computed: {
    s() {
      return this.$style;
    }
  }
};
</script>

<style scoped lang="less" module>
.publicityDetail2 {
  width: 100%;
  box-sizing: border-box;
  font-size: 18px;
  line-height: 32px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;

  h3 {
    font-weight: bold;
    font-size: 28px;
    line-height: 52px;
    align-self: center;
  }
  
  div {
    text-align: left;
  }

  img {
    margin-top: 30px;
    width: 100%;
  }

  p {
    text-indent: 2em;
    margin: 15px 0 0;
    text-align: left;
    margin-block-end: 0;
    margin-block-start: 0;
  }

  p + img {
    margin-left: 2em;
  }

  img + p {
    margin-top: 30px;
  }
}
</style>
